export default __webpack_public_path__ + "static/media/compass.8a908a72.png";